"use client"

import * as React from "react"
import * as AvatarPrimitive from "@radix-ui/react-avatar"

import { cn } from "../../lib/utils"
import clsx from "clsx"
import { Dialog, DialogContent, DialogTrigger } from "../ui/dialog"

const Avatar = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>
>(({ className, ...props }, ref) => (
    <AvatarPrimitive.Root
        ref={ref}
        className={cn(
            "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
            className
        )}
        {...props}
    />
))
Avatar.displayName = AvatarPrimitive.Root.displayName

const AvatarImage = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Image>,
    React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({ className, ...props }, ref) => (
    <AvatarPrimitive.Image
        ref={ref}
        className={cn("aspect-square h-full w-full", className)}
        {...props}
    />
))
AvatarImage.displayName = AvatarPrimitive.Image.displayName

const AvatarFallback = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Fallback>,
    React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>
>(({ className, ...props }, ref) => (
    <AvatarPrimitive.Fallback
        ref={ref}
        className={cn(
            "flex h-full w-full items-center justify-center rounded-full bg-muted",
            className
        )}
        {...props}
    />
))
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName

const AvatarCustom = ({ src, alt, width = 100, height = 100, noRound = false }: { src: string, alt: string, width?: number, height?: number, noRound?: boolean }) => {
    return (

        <Dialog>
            <DialogTrigger asChild>
                <Avatar
                    className={clsx({
                        "rounded-full": !noRound,
                        "rounded-none": noRound
                    })}
                    style={{ width: `${width}px`, height: `${height}px` }}
                >
                    <AvatarImage src={src} alt={alt} width={'100%'} height={'100%'} />
                    <AvatarFallback>{alt}</AvatarFallback>
                </Avatar>
            </DialogTrigger>
            <DialogContent className="bg-transparent border-none w-[max-content] max-w-[100%] h-[90%] flex justify-center items-center">
                <Avatar
                    className={clsx({
                        "rounded-none": true,
                        "w-[500px] h-[500px]": true
                    })}

                >
                    <AvatarImage src={src} alt={alt} className="h-[90%] object-contain" />
                    <AvatarFallback>{alt}</AvatarFallback>
                </Avatar>
            </DialogContent>
        </Dialog>
    )
}

export { Avatar, AvatarImage, AvatarFallback, AvatarCustom }
